import React from 'react';

function BillingTileHeader({ children }) {
    return <div className="billing-tile-header">
        {children}
    </div>;
}

export default BillingTileHeader;
